import React, { useEffect, useState } from 'react';
import { VIEW_TYPE } from '../../../../../enums/ViewType';
import { SimpleSearch } from '../../../../../reduxToolkit/Search/SearchApi';
import { useDispatch, useSelector } from 'react-redux';
import { TABS_FOODIE } from '../../Model/Models';
import { useParamsContextProvider } from '../../../../../hooks/ParamsContextProvider';
import { GetMealTimeById } from '../../../../../reduxToolkit/FoodieMealTime/MealTimeApi';
import { resetMealById } from '../../../../../reduxToolkit/FoodieMealTime/MealTimeSlice';
import {ACTION_MODEL} from '../../../../../Helpers/ActionModel';
import {SEARCH_MODEL} from '../../../../../components/table/Model/TableModel';
import CustomTh from "../../../../../components/table/CustomTh";
import CustomTd from "../../../../../components/table/CustomTd";
import DropDownMenuProfile from "../../../../../components/DropDown/DropDownMenuProfile";
import {permissionObj} from "../../../../../Helpers/permission";
import DropDownMenuItem from "../../../../../components/DropDown/DropDownMenuItem";
import {DeleteIconsOptions, UpdateIconsOptions} from "../../../../../components/buttons/IconButtons";
import TableFunction from "../../../../../components/table/TableFunction";
import {EMPTY_VALUES} from "../../../../../Apis/functions";
import {GetFirstFoodieSetting} from "../../../../../reduxToolkit/Foodie/FoodieApi";
import {renderCost} from "../../Menu/Model/Model";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param selectForDelete
 * @param setSelectForDelete
 * @param {boolean} modified - Flag to track data modifications.
 *@param {Function} setModified - Setter used to update the `modified` flag and trigger data reloads (required).
 * @returns {{getActionsButtons: ((function(*=, *): *)|*), pagination, isAllChecked: boolean, handleMenuModalClose: handleMenuModalClose, tbody: [], thead: [], permission: *, handleDeleteAll: handleDeleteAll, rowsPerPage, menuModalShow: boolean, DEV: *, t: TFunction<"translation", undefined>, searchId: string, handleCheckboxChange: handleCheckboxChange, itemSelected: unknown, tableId: string, page}}
 * @constructor
 */
const MealsTableApp = ({ selectForDelete, setSelectForDelete, modified, setModified, option }) => {
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const costInfo = useSelector((state) => state.employeeFoodieSlice)?.getFirstFoodieSetting;
    const { paramsContext, setParamsContext } = useParamsContextProvider();
    const tableId = "tbl_st_shifts";
    const searchId = "txt_st_search_shifts";
    const [searchResults, setSearchResults] = useState('');
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [search, setSearch] = useState(false);
    const [bodyForExport, setBodyForExport] = useState('');
    const [searchElement, setSearchElement] = useState('');
    const [menuModalShow, setMenuModalShow] = useState(false);
    const [itemSelected, setItemSelected] = useState(null);
    let view = VIEW_TYPE.LIST;

    useEffect(() => {
        dispatch(GetFirstFoodieSetting());
    }, []);

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} classes='first_head'>{t('name')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('starts_at')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('ends_at')}</CustomTh>,
            costInfo?.isMealTimeCost &&  <CustomTh tableId={tableId}>{t('meal_cost')}</CustomTh>
        ];
    };
    const getTbody = () => {
        if (!searchResults || searchResults?.content?.length === 0)
            return {
                body: [],
                data: [],
            };


        let body = searchResults?.content?.map(item => {
            return (
                [
                    <CustomTd tableId={tableId} classes={'first-column'}>{item?.name}</CustomTd>,
                    <CustomTd tableId={tableId}>{item?.startTime || EMPTY_VALUES.DEFAULT}</CustomTd>,
                    <CustomTd tableId={tableId}>{item?.endTime || EMPTY_VALUES.DEFAULT}</CustomTd>,
                    costInfo?.isMealTimeCost && <CustomTd tableId={tableId}>
                        {renderCost(item?.cost)}
                    </CustomTd>
                ]
            );
        });

        return {
            body: body,
            data: searchResults?.content,
        };
    };


    const getActionsButtons = (item, index) => {
        return <>
            <DropDownMenuProfile
                openMenu={openMenu}
                handleMenuToggle={handleMenuToggle}
                menuId={`menu-${item.id}`}
            >
                {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_MEAL_TIME_UPDATE)) &&
                <DropDownMenuItem
                    index={index}
                    handleClose={handleClose}
                    name={t("update")}
                    icon={<UpdateIconsOptions/>}
                    click={() => {
                        setItemSelected({action: ACTION_MODEL.UPDATE, item: item})
                    }}
                />
                }


                {(DEV || permission?.includes(permissionObj?.WEB_FOODIE_MEAL_TIME_DELETE)) &&
                <DropDownMenuItem
                    index={index}
                    handleClose={handleClose}
                    name={t("delete")}
                    fontColor='font-color-error-600'
                    iconColor={"icon-color-error-code-600"}
                    icon={<DeleteIconsOptions/>}
                    click={() => {
                        setItemSelected({action: ACTION_MODEL.DELETE, item: item})
                    }}
                />
                }
            </DropDownMenuProfile>
        </>;
    }

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({page: page, size: rowsPerPage, model: option, key: searchElement, view: view});
        setBodyForExport(body)
        dispatch(SimpleSearch({ body })).then(({ payload: { data: { data, success } } }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            }
        );
    }
    /**
     * Pagination for list view, and other
     */
    const {
        t,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        openMenu,
        handleMenuToggle,
        handleClose,
        pagination,
        page,
        rowsPerPage
    } = TableFunction({
        selectedList: selectForDelete,
        setSelectedList: setSelectForDelete,
        data: searchResults,
        view,
        labelRowsPerPage:'service_time_per_page',
        getTbody,
        getThead,
        setIsAllChecked,
        fixedPagination: false, // Disable fixed pagination
        hasContainer: true, // Enable container for the table

        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
        dependencies: [costInfo]
    });


    /**
     * useEffect to open or close the create meals modal.
     */
    useEffect(() => {
        if (itemSelected && itemSelected.action === ACTION_MODEL.UPDATE) {
            handleUpdate(itemSelected.item)
        }else if(itemSelected && itemSelected.action === ACTION_MODEL.DELETE){
            handleDelete(itemSelected.item);
        }
    }, [itemSelected]);

    /**
     * useEffect to open or close the create meals modal.
     */
    useEffect(() => {
        if (paramsContext && paramsContext?.tabIndex == TABS_FOODIE.SCHEDULES.INDEX) {
            setMenuModalShow(paramsContext?.modalCreate)
        }
    }, [paramsContext, paramsContext?.modalCreate]);

    /**
     * useEffect to set the setIsAllChecked variable
     */
    useEffect(() => {
        if (selectForDelete.length <= 0) {
            setIsAllChecked(false)
        }
    }, [selectForDelete]);

    /**
     * Function to fetch the data of a meal and redirect to the update view.
     * @param item
     * @returns {Promise<void>}
     */
    const handleUpdate = async (item) => {
        const { payload: { data: { data } } } = await dispatch(GetMealTimeById(item.id));
        if (data?.id) {
            setParamsContext(prev => ({
                ...prev,
                modalCreate: true
            }));
        }
        setItemSelected(item);
    };

    /**
     * Function to show the delete modal
     * @param item
     */
    const handleDelete = (item) => {
        setSelectForDelete([item.id])
        setParamsContext(prev => ({
            ...prev,
            modalDelete: true
        }));
    };

    /**
     * Function to hide the create modal.
     */
    const handleMenuModalClose = () => {
        dispatch(resetMealById())
        if (setParamsContext) {
            setParamsContext(prev => ({
                ...prev,
                modalCreate: false
            }));
        }
    }

    /**
     * Function to show the create modal.
     * @returns {Promise<void>}
     */
    const handleCreate = async () => {
        setParamsContext(prev => ({
            ...prev,
            modalCreate: true
        }));
    };

    return {
        DEV,
        permission,
        t,
        tableId,
        searchId,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        getActionsButtons,
        pagination,
        isAllChecked,
        menuModalShow,
        handleMenuModalClose,
        handleCreate,
        setBodyForExport,
        setSearchResults,
        setSearchElement,
        page,
        rowsPerPage,
        setSimpleSearch,
        search,
        setSearch,
        searchElement
    }

}
export default MealsTableApp;
